import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-lines */
import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { DEFAULT_DEBOUNCE_DELAY, DEFAULT_DINAMIC_MAP_URL, DEFAULT_FETCH_COEFFICIENT, DEFAULT_YANDEX_API_VERSION, DEFAULT_ZOOM_RANGE } from '../../constants';
import { getCurrentMedia, getDataForHugeFetch, getFetchData, getLanguage, sortMedia } from '../../utils';
import { MapRouteInfo } from '../MapRouteInfo';
import { NoPanorama } from '../NoPanorama/NoPanorama';
import { RulerButton, ZoomButtons } from '../CustomControls';
import { YMap } from '../YMap';
import { MapVersionError } from './errors';
import { createStyleElement } from './helpers';
import { makeCustomStyles } from './helpers/makeCustomStyles';
import * as styles from './Map.css';
import { EMapState, EMapStatus, EPanoramaState } from './types';

/**
 * React-компонент карты,
 * который используя фасад YMap
 * реализует функционал карты
 * */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Map = /*#__PURE__*/function (_React$PureComponent) {
  function Map() {
    var _this$props$firstPain8, _this$props$firstPain9;
    var _this;
    _classCallCheck(this, Map);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Map, [].concat(args));
    /** Ссылка на элемент в который добавляются яндекс карты  */
    _defineProperty(_this, "_containerRef", /*#__PURE__*/React.createRef());
    /** Массив геообъектов, добавленных на карту */
    _defineProperty(_this, "_geoObjects", []);
    /** Экземпляр класса YMap. Класс реализует фасад над методами библиотеки яндекс карт */
    _defineProperty(_this, "_map", void 0);
    /** Ссылка на DOM элемент, содержащий кастомные стили */
    _defineProperty(_this, "_styleElement", void 0);
    /** Предыдущее состояние карты */
    _defineProperty(_this, "_mapStateBeforePanorama", EMapState.DEFAULT);
    _defineProperty(_this, "state", {
      activeRoute: null,
      currentMedia: null,
      isFullscreen: false,
      panorama: EPanoramaState.CLOSED,
      state: EMapState.DEFAULT,
      status: EMapStatus.LOADING
    });
    // ----------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------
    /** Добавляет геообъекты на карту и события для них */
    _defineProperty(_this, "addGeoObjects", function (geoObjects) {
      _this._map.removeBalloon();
      _this._map.addGeoObjects(geoObjects);
    });
    // ----------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------
    /** Удаляет геообъекты с карты */
    _defineProperty(_this, "removeGeoObjects", function (geoObjects) {
      var shouldRemoveBalloon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this._map.removeGeoObjects(geoObjects);
      if (shouldRemoveBalloon) {
        _this._map.removeBalloon();
      }
    });
    // ----------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------
    /** Удаляет все геообъекты с карты */
    _defineProperty(_this, "removeAllGeoObjects", function () {
      _this._map.removeAllGeoObjects();
      _this._map.removeBalloon();
    });
    // ----------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------
    /** Публичный метод для принудительного сброса состояния карты до значения по-умолчанию */
    _defineProperty(_this, "resetMapState", function () {
      var currentState = _this.state.state;
      switch (currentState) {
        case EMapState.ROUTING:
          _this._map.closeRouteControl();
          break;
        case EMapState.PANORAMA:
          _this._map.closePanorama();
          break;
        default:
          return;
      }
    });
    /** Публичный метод для принудительного изменения состояния карты и включения расчета маршрута по заданным координатам  */
    _defineProperty(_this, "startRouting", function (from, to, filter, routingMode, viewType) {
      _this._startRouting(from, to, filter, routingMode, viewType);
    });
    /** Публичный метод для подгона яндекс-карты под размеры внешнего контейнера */
    _defineProperty(_this, "fitToViewport", function () {
      _this._map.redraw();
    });
    /* Получает зум карты */
    _defineProperty(_this, "getZoom", function () {
      return _this._map.getZoom();
    });
    /* Центрирует карту с заданным зумом */
    _defineProperty(_this, "setCenterAndZoom", function (centerCoordinates, zoom, animationDuration, additionalOptions) {
      var currentMedia = _this.state.currentMedia;
      _this._setCenterAndZoom(_objectSpread(_objectSpread({}, currentMedia), {}, {
        options: {
          center: centerCoordinates,
          defaultZoom: zoom,
          animationDuration: animationDuration,
          styles: currentMedia.options.styles
        }
      }), additionalOptions);
    });
    // ----------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------
    /** Публичный метод для добавления маршрута на карту по координатам */
    _defineProperty(_this, "addRoute", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(routeId, from, to, routingMode) {
        var zoomMargin,
          onActiveRouteChange,
          activeRoute,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              zoomMargin = _args.length > 4 && _args[4] !== undefined ? _args[4] : [0, 0];
              onActiveRouteChange = _this.props.firstPaintOptions.onActiveRouteChange;
              _this._map.removeBalloon();
              _context.next = 5;
              return _this._map.addMultiRoute(routeId, from, to, routingMode, zoomMargin);
            case 5:
              activeRoute = _context.sent;
              _this.setState({
                activeRoute: activeRoute
              });
              if (onActiveRouteChange) {
                onActiveRouteChange(activeRoute);
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }());
    /** Удаляет маршрут с карты по его идентификатору */
    _defineProperty(_this, "removeRoute", function (routeId) {
      var onActiveRouteChange = _this.props.firstPaintOptions.onActiveRouteChange;
      _this._map.removeMultiRoute(routeId);
      _this.setState({
        activeRoute: null
      });
      if (onActiveRouteChange) {
        onActiveRouteChange(null);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------
    /** Принудительно перерисовывает карту чтобы она вписалась в размеры нового
     *  внешнего контейнера(например при ресайзе окна) */
    _defineProperty(_this, "_redraw", function () {
      setTimeout(_this._map.redraw, _this.state.currentMedia.options.animationDuration + 100);
    });
    // ----------------------------------------------------------------------------------------------------
    _defineProperty(_this, "_setCenterAndZoom", function (currentMedia, additionalOptions) {
      _this._map.setCenterAndZoom(_objectSpread({
        center: [currentMedia.options.center.lng, currentMedia.options.center.lat],
        zoom: currentMedia.options.defaultZoom,
        duration: currentMedia.options.animationDuration
      }, additionalOptions));
    });
    // ----------------------------------------------------------------------------------------------------
    /** Агрегирует и возвращает данные, необходимые для инициализации карты */
    _defineProperty(_this, "_getDataForYMap", function (currentMedia) {
      var _this$props$firstPain = _this.props.firstPaintOptions,
        zoomRange = _this$props$firstPain.zoomRange,
        clustersOptions = _this$props$firstPain.clusters,
        restrictMapArea = _this$props$firstPain.restrictMapArea,
        onMove = _this$props$firstPain.onMove,
        maxGeoObjectsPerLoad = _this$props$firstPain.maxGeoObjectsPerLoad,
        geoObjectsLoadDelay = _this$props$firstPain.geoObjectsLoadDelay,
        disableScrollZoom = _this$props$firstPain.disableScrollZoom,
        onPanoramaButtonClick = _this$props$firstPain.onPanoramaButtonClick;
      var _currentMedia$options = currentMedia.options,
        center = _currentMedia$options.center,
        defaultZoom = _currentMedia$options.defaultZoom;
      return {
        center: center,
        defaultZoom: defaultZoom,
        clustersOptions: clustersOptions,
        restrictMapArea: restrictMapArea,
        onMove: onMove,
        onActiveRouteChange: _this._handleActiveRouteChange,
        onRouteBuildingInit: _this._handleRouteBuildingInit,
        onRouteBuildingSuccess: _this._handleRouteBuildingSuccess,
        onRoutingEnd: _this._handleEndRouting,
        onRoutingStart: _this._handleStartRouting,
        maxGeoObjectsPerLoad: maxGeoObjectsPerLoad,
        geoObjectsLoadDelay: geoObjectsLoadDelay,
        disableScrollZoom: disableScrollZoom,
        zoomRange: zoomRange || DEFAULT_ZOOM_RANGE,
        onActionEnd: _this._handleActionEndDebounced,
        onGeoObjectClick: _this._handleGeoObjectClick,
        onPanoramaButtonClick: onPanoramaButtonClick,
        onPanoramaStateChange: _this._onPanoramaStateChange,
        onFullscreenStateChange: _this._onFullscreenStateChange,
        container: _this._containerRef,
        successCallback: _this._handleYMapLoaded,
        errorCallback: _this._handleYMapError,
        onBalloonOpen: _this._handleBalloonOpen,
        onBalloonClose: _this._handleBalloonClose
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Функция запроса данных для геообъектов */
    _defineProperty(_this, "_fetchData", function (data) {
      var hugeBbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
        geoObjectNames = _this$props.geoObjectNames,
        _this$props$firstPain2 = _this$props.firstPaintOptions,
        _this$props$firstPain3 = _this$props$firstPain2.fetch,
        fetchOptions = _this$props$firstPain3 === void 0 ? {} : _this$props$firstPain3,
        zoomRange = _this$props$firstPain2.zoomRange;
      var onGeoObjectsFetch = fetchOptions.onGeoObjectsFetch,
        hasOptimization = fetchOptions.hasOptimization,
        fetchCoefficient = fetchOptions.fetchCoefficient;
      if (!onGeoObjectsFetch) {
        return;
      }
      var currentData = getFetchData({
        data: data,
        geoObjectNames: geoObjectNames
      });

      // запрашиваем данные по объектам внутри видимого bbox
      onGeoObjectsFetch(currentData).then(function (objects) {
        // добавляем новые объекты к существующим в список
        _this._geoObjects = _this._geoObjects.concat(objects);

        // добавляем новые объекты на карту предварительно их фильтруя
        _this._map.addGeoObjects(_this._filterGeoObjects(objects));

        // Если нужна оптимизация - запрашиваем данные по еще большему bbox
        // Необходимо что бы подгрузить данные для ближайших объектам заранее,
        // т.к. их скоро может посмотреть пользователь
        if (!hugeBbox && hasOptimization) {
          _this._fetchData(getDataForHugeFetch({
            data: currentData,
            fetchCoefficient: fetchCoefficient || DEFAULT_FETCH_COEFFICIENT,
            geoObjectNames: geoObjectNames,
            minZoom: (zoomRange || DEFAULT_ZOOM_RANGE).min
          }), true);
        }
      });
    });
    // ----------------------------------------------------------------------------------------------------
    /** Фильтрует геообъекты */
    _defineProperty(_this, "_filterGeoObjects", function (geoObjects) {
      var newGeoObjects = [];
      var i = 0;
      var j = geoObjects.length - 1;
      while (i < j) {
        _this._checkGeoObject(geoObjects[i], newGeoObjects);
        _this._checkGeoObject(geoObjects[j], newGeoObjects);
        i++;
        j--;
      }
      if (i === j) {
        _this._checkGeoObject(geoObjects[i], newGeoObjects);
      }
      return newGeoObjects;
    });
    // ----------------------------------------------------------------------------------------------------
    /** Фильтрует старые геообъекты для удаления и новые для добавления после изменения типов объектов для отображения */
    _defineProperty(_this, "_filterOldAndNewGeoObjects", function (geoObjects, prevGeoObjectNames) {
      var newGeoObjects = [];
      var oldGeoObjects = [];
      var i = 0;
      var j = geoObjects.length - 1;
      while (i < j) {
        _this._checkOldAndNewGeoObjects(geoObjects[i], prevGeoObjectNames, newGeoObjects, oldGeoObjects);
        _this._checkOldAndNewGeoObjects(geoObjects[j], prevGeoObjectNames, newGeoObjects, oldGeoObjects);
        i++;
        j--;
      }
      if (i === j) {
        _this._checkOldAndNewGeoObjects(geoObjects[i], prevGeoObjectNames, newGeoObjects, oldGeoObjects);
      }
      return {
        newGeoObjects: newGeoObjects,
        oldGeoObjects: oldGeoObjects
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Проверяет нужно ли показывать геообъект на карте и добавляет в соответствующий массив */
    _defineProperty(_this, "_checkGeoObject", function (geoObject, newGeoObjects) {
      if (_this.props.geoObjectNames.includes(geoObject.name)) {
        newGeoObjects.push(geoObject);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Проверяет нужно ли добавить/удалить геообъект на карту после изменения типов объектов для отображения
     * и добавляет в соответствующий массив */
    _defineProperty(_this, "_checkOldAndNewGeoObjects", function (geoObject, prevGeoObjectNames, newGeoObjects, oldGeoObjects) {
      if (!_this.props.geoObjectNames.includes(geoObject.name) && prevGeoObjectNames.includes(geoObject.name)) {
        oldGeoObjects.push(geoObject);
      } else if (_this.props.geoObjectNames.includes(geoObject.name) && !prevGeoObjectNames.includes(geoObject.name)) {
        newGeoObjects.push(geoObject);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик успешной загрузка карты */
    _defineProperty(_this, "_handleYMapLoaded", function () {
      var _this$props$firstPain4 = _this.props.firstPaintOptions,
        onMapSuccess = _this$props$firstPain4.onMapSuccess,
        controls = _this$props$firstPain4.controls,
        disableScrollZoom = _this$props$firstPain4.disableScrollZoom;
      _this._map.addGeoObjects(_this._filterGeoObjects(_this._geoObjects));
      _this._map.addControls(controls);
      _this.setState({
        status: EMapStatus.LOADED
      }, function () {
        window.addEventListener('resize', _this._handleResizeDebounced, false);
        if (onMapSuccess) {
          onMapSuccess(); // вызыв обработчика загрузки карты
        }
      }); // карта загружена

      if (disableScrollZoom) {
        _this._map.disableScrollZoom();
      }
      _this._checkYMapsVersion();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Применение кастомных стилей к карте */
    _defineProperty(_this, "_applyCustomStyles", function () {
      var _this$props$firstPain5 = _this.props.firstPaintOptions,
        apiVersion = _this$props$firstPain5.apiVersion,
        suggestPosition = _this$props$firstPain5.suggestPosition;
      var currentVersion = apiVersion || DEFAULT_YANDEX_API_VERSION;
      var styles = makeCustomStyles(currentVersion, suggestPosition);
      var styleElement = createStyleElement(styles);
      document.head.appendChild(styleElement);
      _this._styleElement = styleElement;
    });
    // ----------------------------------------------------------------------------------------------------
    /** Проверка текущей версии карты */
    _defineProperty(_this, "_checkYMapsVersion", function () {
      var apiVersion = _this.props.firstPaintOptions.apiVersion;
      var requiredVersion = apiVersion || DEFAULT_YANDEX_API_VERSION;
      var currentVersion = _this._map.getVersion();
      if (currentVersion !== requiredVersion) {
        _this._handleError(new MapVersionError('Map._checkYMapsVersion', currentVersion, requiredVersion));
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик неудачной загрузки карты с ошибками */
    _defineProperty(_this, "_handleYMapError", function () {
      var onMapError = _this.props.firstPaintOptions.onMapError;
      if (onMapError) {
        onMapError(); // вызов обработчика неудачной загрузки карты с ошибками
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик клика на геообъект*/
    _defineProperty(_this, "_handleGeoObjectClick", function (geoObject, balloonFetchData) {
      var _this$props$firstPain6 = _this.props.firstPaintOptions,
        _this$props$firstPain7 = _this$props$firstPain6.fetch,
        fetchOptions = _this$props$firstPain7 === void 0 ? {} : _this$props$firstPain7,
        onGeoObjectClick = _this$props$firstPain6.onGeoObjectClick;
      var onBalloonHtmlFetch = fetchOptions.onBalloonHtmlFetch,
        onCustomBalloonHtmlFetch = fetchOptions.onCustomBalloonHtmlFetch;
      if (onBalloonHtmlFetch) {
        // запрашиваем html для подсказок(Balloon)
        onBalloonHtmlFetch(geoObject, balloonFetchData).then(function (html) {
          if (html) {
            // добавляем Balloon на карту
            _this._map.addBalloon(_objectSpread(_objectSpread({}, balloonFetchData), {}, {
              html: html
            }), geoObject);
          }
        });
      }
      if (onCustomBalloonHtmlFetch) {
        var customBalloonResult = onCustomBalloonHtmlFetch(geoObject, balloonFetchData);
        customBalloonResult.html.then(function (html) {
          if (html) {
            _this._map.addBalloonWithContainer(_objectSpread(_objectSpread({}, balloonFetchData), {}, {
              html: html,
              closeSelector: customBalloonResult.closeSelector
            }), geoObject);
          }
        });
      }
      if (onGeoObjectClick) {
        onGeoObjectClick(geoObject);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик обновления props */
    _defineProperty(_this, "_handleDidUpdate", function (_ref2) {
      var props = _ref2.props,
        state = _ref2.state,
        prevProps = _ref2.prevProps,
        prevState = _ref2.prevState;
      //  если изменился список объектов разрешенных к отображению
      if (props.geoObjectNames.join('') !== prevProps.geoObjectNames.join('')) {
        var _this$_filterOldAndNe = _this._filterOldAndNewGeoObjects(_this._geoObjects, prevProps.geoObjectNames),
          newGeoObjects = _this$_filterOldAndNe.newGeoObjects,
          oldGeoObjects = _this$_filterOldAndNe.oldGeoObjects;
        _this._map.removeGeoObjects(oldGeoObjects); // удаляем старые объекты, которые больше не нужно показывать
        _this._map.removeBalloon();
        _this._map.addGeoObjects(newGeoObjects); // и дорисовываем объекты новых типов
      }
      // если изменились настройки, зависящие от медиа
      if (state.currentMedia && prevState.currentMedia && JSON.stringify(state.currentMedia) !== JSON.stringify(prevState.currentMedia)) {
        _this._setCenterAndZoom(state.currentMedia); // устанавливаем центр карты и зум
        _this._redraw(); // и перерисовываем карту
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик изменения размеров окна */
    _defineProperty(_this, "_handleResize", function () {
      var currentMedia = getCurrentMedia(sortMedia(_this.props.media));
      _this.setState({
        currentMedia: currentMedia
      });
      _this._setCenterAndZoom(currentMedia);
      _this._redraw();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик окончания действия перемещения/изменения карты  */
    _defineProperty(_this, "_handleActionEndDebounced", debounce(((_this$props$firstPain8 = _this.props.firstPaintOptions.fetch) === null || _this$props$firstPain8 === void 0 ? void 0 : _this$props$firstPain8.debounceDelay) || DEFAULT_DEBOUNCE_DELAY, _this._fetchData));
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик изменения размеров окна */
    _defineProperty(_this, "_handleResizeDebounced", debounce(((_this$props$firstPain9 = _this.props.firstPaintOptions.fetch) === null || _this$props$firstPain9 === void 0 ? void 0 : _this$props$firstPain9.debounceDelay) || DEFAULT_DEBOUNCE_DELAY, _this._handleResize));
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик изменения состояния панорамы */
    _defineProperty(_this, "_onPanoramaStateChange", function (panorama) {
      var _this$props$firstPain10 = _this.props.firstPaintOptions,
        onPanoramaSuccessEnter = _this$props$firstPain10.onPanoramaSuccessEnter,
        onNoPanoramaEnter = _this$props$firstPain10.onNoPanoramaEnter,
        onPanoramaExit = _this$props$firstPain10.onPanoramaExit;
      if (panorama === EPanoramaState.CLOSED) {
        _this.setState({
          state: _this._mapStateBeforePanorama,
          panorama: panorama
        });
        if (onPanoramaExit) {
          onPanoramaExit();
        }
        return;
      }
      var prevMapState = _this.state.state;
      _this._mapStateBeforePanorama = prevMapState;
      _this.setState({
        state: EMapState.PANORAMA,
        panorama: panorama
      });
      if (panorama === EPanoramaState.PANORAMA && onPanoramaSuccessEnter) {
        onPanoramaSuccessEnter();
      }
      if (panorama === EPanoramaState.NO_PANORAMA && onNoPanoramaEnter) {
        onNoPanoramaEnter();
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик изменения состояния полноэкранного режима */
    _defineProperty(_this, "_onFullscreenStateChange", function (status) {
      var _this$props$firstPain11 = _this.props.firstPaintOptions,
        onFullscreenEnter = _this$props$firstPain11.onFullscreenEnter,
        onFullscreenExit = _this$props$firstPain11.onFullscreenExit;
      _this.setState({
        isFullscreen: status
      });
      if (status && !!onFullscreenEnter) {
        onFullscreenEnter();
      }
      if (!status && !!onFullscreenExit) {
        onFullscreenExit();
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик клика по кнопке "Перейти на карту" */
    _defineProperty(_this, "_onNoPanoramaButtonClick", function () {
      _this._onPanoramaStateChange(EPanoramaState.CLOSED);
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик открытия балуна */
    _defineProperty(_this, "_handleBalloonOpen", function (object) {
      var onBalloonOpen = _this.props.firstPaintOptions.onBalloonOpen;
      if (onBalloonOpen) {
        onBalloonOpen(object);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик закрытия балуна */
    _defineProperty(_this, "_handleBalloonClose", function (object) {
      var onBalloonClose = _this.props.firstPaintOptions.onBalloonClose;
      if (onBalloonClose) {
        onBalloonClose(object);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик ошибок карты */
    _defineProperty(_this, "_handleError", function (error) {
      var onError = _this.props.firstPaintOptions.onError;
      if (onError) {
        onError(error);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик перехода в состояние построения маршрута */
    _defineProperty(_this, "_startRouting", function (from, to, filter, routingMode, viewType) {
      _this._map.removeBalloon();
      if (filter !== undefined) {
        _this._setObjectsFilter(filter);
      }
      _this._map.openRouteControl(from, to, routingMode, viewType);
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик выхода из состояния построения маршрута */
    _defineProperty(_this, "_handleEndRouting", function () {
      var onRoutingEnd = _this.props.firstPaintOptions.onRoutingEnd;
      _this.setState({
        activeRoute: null,
        state: EMapState.DEFAULT
      });
      _this._resetObjectsFilter();
      if (onRoutingEnd) {
        onRoutingEnd();
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик входа в состояние построения маршрута */
    _defineProperty(_this, "_handleStartRouting", function () {
      var onRoutingStart = _this.props.firstPaintOptions.onRoutingStart;
      _this.setState({
        state: EMapState.ROUTING
      });
      if (onRoutingStart) {
        onRoutingStart();
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик смены текущего активного маршрута */
    _defineProperty(_this, "_handleActiveRouteChange", function (route) {
      var onActiveRouteChange = _this.props.firstPaintOptions.onActiveRouteChange;
      _this.setState({
        activeRoute: route
      });
      if (onActiveRouteChange) {
        onActiveRouteChange(route);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик отправки запроса на построения маршрута */
    _defineProperty(_this, "_handleRouteBuildingInit", function (params) {
      var onRouteBuildingInit = _this.props.firstPaintOptions.onRouteBuildingInit;
      if (onRouteBuildingInit) {
        onRouteBuildingInit(params);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработчик отправки запроса на построения маршрута */
    _defineProperty(_this, "_handleRouteBuildingSuccess", function (params) {
      var onRouteBuildingSuccess = _this.props.firstPaintOptions.onRouteBuildingSuccess;
      if (onRouteBuildingSuccess) {
        onRouteBuildingSuccess(params);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Фильтрация гео-объектов */
    _defineProperty(_this, "_setObjectsFilter", function (filterFunction) {
      _this._map.filterGeoObjects(filterFunction);
    });
    /** Сброс фильтрации гео-объектов */
    _defineProperty(_this, "_resetObjectsFilter", function () {
      _this._map.filterGeoObjects(null);
    });
    return _this;
  }
  _inherits(Map, _React$PureComponent);
  return _createClass(Map, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /* istanbul ignore next */
      if (typeof window === 'undefined') {
        return;
      }
      var currentMedia = getCurrentMedia(sortMedia(this.props.media));
      var _this$props$firstPain12 = this.props.firstPaintOptions,
        apiKey = _this$props$firstPain12.apiKey,
        apiVersion = _this$props$firstPain12.apiVersion,
        language = _this$props$firstPain12.language,
        suggestApiKey = _this$props$firstPain12.suggestApiKey;
      var mapUrl = DEFAULT_DINAMIC_MAP_URL.replace(':version', apiVersion || DEFAULT_YANDEX_API_VERSION);
      var apiUrl = "".concat(mapUrl, "&apikey=").concat(apiKey);
      if (suggestApiKey) {
        apiUrl = "".concat(apiUrl, "&suggest_apikey=").concat(suggestApiKey);
      }

      // устанавливаем текущие настройки, зависящие от медиа
      this.setState({
        currentMedia: currentMedia
      });

      // инициализируем  яндекс карты, получаем инстанс
      this._map = new YMap(this._getDataForYMap(currentMedia));
      this._map.init("".concat(apiUrl).concat(getLanguage(apiUrl, language)));
      this._applyCustomStyles();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._handleResizeDebounced, false);
      this._styleElement.remove();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Перерисовываем некоторые элементы карты при получении новых props.
      // Делаем это после изменения props.
      // Изменение пропс является инициатором изменений внутри карты.
      /* istanbul ignore next */
      if (this.state.status === EMapStatus.LOADED) {
        this._handleDidUpdate({
          props: this.props,
          state: this.state,
          prevProps: prevProps,
          prevState: prevState
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$_map;
      var _this$state = this.state,
        activeRoute = _this$state.activeRoute,
        status = _this$state.status,
        panorama = _this$state.panorama,
        currentMedia = _this$state.currentMedia,
        isFullscreen = _this$state.isFullscreen;
      var _this$props$firstPain13 = this.props.firstPaintOptions,
        controls = _this$props$firstPain13.controls,
        firstPaintStyles = _this$props$firstPain13.styles,
        id = _this$props$firstPain13.id,
        displayRouteInfo = _this$props$firstPain13.displayRouteInfo,
        zoomRange = _this$props$firstPain13.zoomRange,
        ExternalMapRouteInfo = _this$props$firstPain13.mapRouteInfoComponent,
        onRulerEnter = _this$props$firstPain13.onRulerEnter,
        onRulerExit = _this$props$firstPain13.onRulerExit;

      /* istanbul ignore next */
      var externalStyles = currentMedia ? currentMedia.options.styles : firstPaintStyles;
      var isRouteInfoVisible = Boolean(displayRouteInfo && activeRoute);
      var isPanoramaClosed = panorama === EPanoramaState.CLOSED;
      var ruler = (_this$_map = this._map) === null || _this$_map === void 0 ? void 0 : _this$_map.getRuler();
      var rulerControl = controls.find(function (control) {
        return control.type === 'RulerControl';
      });
      var isRulerVisible = status === EMapStatus.LOADED && Boolean(rulerControl) && ruler && isPanoramaClosed;
      var zoomControl = controls.find(function (control) {
        return control.type === 'ZoomControl';
      });
      var isZoomControlVisible = status === EMapStatus.LOADED && Boolean(zoomControl) && isPanoramaClosed;
      return /*#__PURE__*/_jsxs("div", {
        style: externalStyles,
        className: "".concat(styles['container'], " ").concat(isFullscreen ? styles['container--fullscreen'] : ''),
        children: [/*#__PURE__*/_jsx("div", {
          style: externalStyles,
          ref: this._containerRef,
          className: status !== EMapStatus.LOADED ? styles['map-hidden'] : styles['map'],
          id: id || 'map'
        }), /*#__PURE__*/_jsx("div", {
          style: externalStyles,
          className: status !== EMapStatus.LOADING ? styles['map-hidden'] : styles['map'],
          children: /*#__PURE__*/_jsx("div", {
            className: styles['preloader']
          })
        }), panorama === EPanoramaState.NO_PANORAMA && /*#__PURE__*/_jsx(NoPanorama, {
          onClick: this._onNoPanoramaButtonClick,
          isFullscreen: isFullscreen
        }), isRouteInfoVisible && (ExternalMapRouteInfo ? /*#__PURE__*/_jsx(ExternalMapRouteInfo, {
          route: activeRoute,
          isFullscreen: isFullscreen
        }) : /*#__PURE__*/_jsx("div", {
          className: styles['route-info'],
          children: /*#__PURE__*/_jsx(MapRouteInfo, {
            route: activeRoute
          })
        })), isRulerVisible && /*#__PURE__*/_jsx("div", {
          className: isFullscreen ? styles['fullscreen-ruler'] : styles['ruler'],
          children: /*#__PURE__*/_jsx(RulerButton, {
            ruler: ruler,
            control: rulerControl,
            onRulerEnter: onRulerEnter,
            onRulerExit: onRulerExit
          })
        }), isZoomControlVisible && /*#__PURE__*/_jsx("div", {
          className: isFullscreen ? styles['fullscreen-zoom'] : styles['zoom'],
          children: /*#__PURE__*/_jsx(ZoomButtons, {
            map: this._map,
            zoomRange: zoomRange,
            control: zoomControl
          })
        })]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      /* istanbul ignore next */
      if (typeof window === 'undefined') {
        return null;
      }

      // устанавливаем текущие настройки, зависящие от медиа при получении новых props
      return {
        currentMedia: getCurrentMedia(sortMedia(props.media))
      };
    }
  }]);
}(React.PureComponent);